import React from "react";
import { cn } from "@/utils/cn";

interface PromptSuggestion {
  label: string;
  prompt: string;
  icon?: string;
}

interface PromptSuggestionsProps {
  onSelectPrompt: (prompt: string) => void;
  className?: string;
}

const defaultPrompts: PromptSuggestion[] = [
  {
    label: "Listar Tools",
    prompt: "Liste todas as tools disponíveis",
    icon: "🔧",
  },
  {
    label: "Listar Resources",
    prompt: "Liste todos os resources disponíveis",
    icon: "📦",
  },
  {
    label: "Visão geral Kpay",
    prompt: "Forneça uma visão geral completa do projeto Kpay, incluindo: arquitetura do sistema, principais funcionalidades, tecnologias utilizadas, integrações disponíveis e objetivos do projeto.",
    icon: "🎯",
  },
];

export const PromptSuggestions: React.FC<PromptSuggestionsProps> = ({
  onSelectPrompt,
  className = "",
}) => {
  return (
    <div
      className={cn(
        "flex flex-wrap gap-2 px-4 py-3 bg-gray-50 border-b border-gray-200",
        className
      )}
    >
      {defaultPrompts.map((suggestion, index) => (
        <button
          key={index}
          onClick={() => onSelectPrompt(suggestion.prompt)}
          className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-full hover:bg-gray-100 hover:border-gray-400 transition-colors"
          type="button"
        >
          {suggestion.icon && <span>{suggestion.icon}</span>}
          <span>{suggestion.label}</span>
        </button>
      ))}
    </div>
  );
};

